import { t } from "i18next";

export const CashFields = [
  {
    IdAppForm: 62,
    Id: 6200010,
    FieldName: "name",
    FieldType: "bigint",
    FieldTitle: t("Assigned to"),
    Position: 1,
    cssClasss: "col-4",
    HtmlType: "text",
    PlaceHolder: null,
    DefaultValue: null,
    OptionValues: null,
    DataSource: null,
    Required: false,
    Visible: true,
    ReadOnly: true,
  },
  {
    IdAppForm: 64,
    Id: 6400010,
    FieldName: "IdBusinessUnit", // Cambiado de IdBillingBusinessUnit a IdBusinessUnit
    FieldType: "bigint",
    FieldTitle: t("Business Unit"),
    Position: 3,
    cssClasss: "col-4",
    HtmlType: "select",
    PlaceHolder: "",
    DefaultValue: null,
    OptionValues: null,

    DataSource:
      '{"HashID": "be60cb6ae9e3b5bfc7eb84cb4127a5f0b071e40ad1a9dd2dc20035c778f507ef"}',
    Required: false,
    Visible: true,
    ReadOnly: true,
    GroupBy: 0,
  },
  {
    IdAppForm: 64,
    Id: 6400008,
    FieldName: "OpeningDate",
    FieldType: "datetime",
    FieldTitle: t("Opening Date"),
    Position: 8,
    cssClasss: "col-4",
    HtmlType: "date",
    PlaceHolder: "",
    DefaultValue: "",
    OptionValues: null,
    DataSource: null,
    Required: false,
    Visible: true,
    ReadOnly: true,
  },
  {
    FieldName: "Cashfund",
    FieldType: "money",
    FieldTitle: t("Cash fund"),
    cssClasss: "col-12",
    HtmlType: "number",
    PlaceHolder: "",
    DefaultValue: 0,
    OptionValues: null,
    min: 0,
    DataSource: "",
    Required: true,
    Visible: true,
    ReadOnly: false,
    dependOf: null,
  },
  {
    FieldName: "comment",
    FieldType: "varchar",
    FieldTitle: t("Comment"),
    cssClasss: "col-12",
    HtmlType: "textarea",
    PlaceHolder: "",
    DefaultValue: "",
    OptionValues: null,
    DataSource: null,
    Required: false,
    Visible: true,
    ReadOnly: false,
  },
];
